@if (explorer.result(); as bestellungen) {
  <div class="pb-3">
    <div class="flex flex-col-reverse full-width bg-surface lg:bg-transparent -mt-2 sticky -top-2 !z-10">
      <div class="lg:-mt-3 w-full p-4 bg-surface border-b border-gray-300 border-solid">
        <div class="font-bold text-sm text-primary-400 mt-3 mb-3">
          {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG.TITEL_BESTELLUNGEN' | translate}}
        </div>
        <soft-filter-and-sort
          class="flex flex-row w-full mt-4"
          [filterConfig]="filterConfig"
          [sortConfig]="sortConfig"
          [explorer]="explorer">
        </soft-filter-and-sort>
      </div>
    </div>
    @if ((loading$ | async) === false) {
      <div class="flex flex-grow overflow-auto full-width w-full z-[0] lg:-mt-3 relative">
        @let anwender = currentAnwender();
          <div class="flex flex-col gap-3 w-full px-4 py-2 lg:py-4 mt-2">
            @for (bestellung of bestellungen; track bestellung.id) {
              <div
                class="soft-card rounded-sm flex flex-col w-full justify-between cursor-pointer !p-3"
                [ngClass]="{'!bg-red-300': bestellung?.kopfbskommExzessResult?.anwender && (bestellung?.kopfbskommExzessResult?.anwender?.anwender !== anwender?.username)}"
                (click)="artikelAuswahlLaden(bestellung)">
                <div class="flex flex-row w-full justify-between">
                  <div class="flex flex-col w-4/5 gap-2">
                    <div class="flex flex-row w-full justify-between text-sm text-light">
                      <span>{{bestellung?.lieferant?.nummer}}</span>
                      <span>{{bestellung?.kopfbskommExzessResult?.anwender?.anwender}}</span>
                    </div>
                    <div class="flex flex-row w-full font-semibold">
                      {{bestellung?.lieferant?.kurzbez}}
                    </div>
                    <div class="flex flex-row w-full">
                      {{$safeNavigationMigration(bestellung?.lieferdatum) | format:'DATE.DEFAULT'}} | {{bestellung?.belegnummer}}
                    </div>
                  </div>
                  <div class="flex flex-col w-1/5 items-end self-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                  </div>
                </div>
              </div>
              } @empty {
              <div class="flex text-sm text-lighter w-full justify-center items-center mt-3">
                {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG.LABEL_KEINE_BESTELLUNGEN_VORHANDEN' | translate}}
              </div>
            }
          </div>
      </div>
    } @else {
      <div class="flex flex-col mt-3 pb-5 gap-3">
        <div class="flex soft-card rounded w-full h-24" *softRepeat="5">
          <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
            <div class="h-4 w-20 skeleton rounded"></div>
            <div class="h-4 w-24 skeleton rounded"></div>
            <div class="h-4 w-36 skeleton rounded"></div>
          </div>
        </div>
      </div>
    }
  </div>
}
